var React = require('react');

function Bw (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},[React.createElement("path",{"fill":"#00cbff","d":"M0 0h640v480H0z","key":0}),React.createElement("path",{"fill":"#fff","d":"M0 160h640v160H0z","key":1}),React.createElement("path",{"d":"M0 186h640v108H0z","key":2})]));
}

Bw.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Bw;

Bw.default = Bw;
